import React from 'react';
import { Package, BookOpen, Gift, CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PackageSummary() {
  return <section className="py-20 bg-white relative" data-id="element-381">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-382">
        <FadeIn data-id="element-383">
          <div className="text-center mb-12" data-id="element-384">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-navy/5 text-navy mb-6" data-id="element-385">
              <Package size={32} data-id="element-386" />
            </div>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-387">
              Resumen del Paquete Completo
            </h2>
            <div className="w-24 h-1 bg-amber mx-auto rounded-full" data-id="element-388"></div>
          </div>

          <div className="bg-white rounded-3xl border border-navy/10 shadow-xl overflow-hidden mb-12" data-id="element-389">
            <div className="p-6 md:p-8 bg-navy text-white flex items-center justify-between" data-id="element-390">
              <h3 className="text-xl font-bold flex items-center gap-2" data-id="element-391">
                <Package size={24} className="text-amber" data-id="element-392" />
                Qué recibís hoy
              </h3>
              <span className="font-bold text-white/70" data-id="element-393">Valor real</span>
            </div>

            <div className="divide-y divide-navy/5" data-id="element-394">
              <div className="p-6 md:p-8 flex items-center justify-between hover:bg-offwhite transition-colors" data-id="element-395">
                <div className="flex items-center gap-4" data-id="element-396">
                  <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center text-teal flex-shrink-0" data-id="element-397">
                    <BookOpen size={20} data-id="element-398" />
                  </div>
                  <span className="text-lg font-bold text-navy" data-id="element-399">
                    Ebook Principal: Escudo de Confianza
                  </span>
                </div>
                <span className="text-lg text-navy/60 font-medium" data-id="element-400">$27.00</span>
              </div>

              <div className="p-6 md:p-8 flex items-center justify-between hover:bg-offwhite transition-colors" data-id="element-401">
                <div className="flex items-center gap-4" data-id="element-402">
                  <div className="w-10 h-10 rounded-full bg-amber/10 flex items-center justify-center text-amber-dark flex-shrink-0" data-id="element-403">
                    <Gift size={20} data-id="element-404" />
                  </div>
                  <span className="text-lg font-medium text-navy" data-id="element-405">
                    Bonus #1: Kit de Frases CERO PÁNICO
                  </span>
                </div>
                <span className="text-lg text-navy/60 font-medium" data-id="element-406">$17.00</span>
              </div>

              <div className="p-6 md:p-8 flex items-center justify-between hover:bg-offwhite transition-colors" data-id="element-407">
                <div className="flex items-center gap-4" data-id="element-408">
                  <div className="w-10 h-10 rounded-full bg-amber/10 flex items-center justify-center text-amber-dark flex-shrink-0" data-id="element-409">
                    <Gift size={20} data-id="element-410" />
                  </div>
                  <span className="text-lg font-medium text-navy" data-id="element-411">
                    Bonus #2: Mapa ZONAS SEGURAS
                  </span>
                </div>
                <span className="text-lg text-navy/60 font-medium" data-id="element-412">$17.00</span>
              </div>

              <div className="p-6 md:p-8 flex items-center justify-between hover:bg-offwhite transition-colors" data-id="element-413">
                <div className="flex items-center gap-4" data-id="element-414">
                  <div className="w-10 h-10 rounded-full bg-amber/10 flex items-center justify-center text-amber-dark flex-shrink-0" data-id="element-415">
                    <Gift size={20} data-id="element-416" />
                  </div>
                  <span className="text-lg font-medium text-navy" data-id="element-417">
                    Bonus #3: Reunión en 20 Min
                  </span>
                </div>
                <span className="text-lg text-navy/60 font-medium" data-id="element-418">$13.00</span>
              </div>
            </div>

            <div className="p-6 md:p-8 bg-offwhite-dark border-t border-navy/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-419">
              <div className="text-center md:text-left" data-id="element-420">
                <span className="block text-navy/60 font-bold uppercase tracking-wider text-sm mb-1" data-id="element-421">
                  Valor Total Real
                </span>
                <span className="text-3xl font-bold text-navy/40 line-through" data-id="element-422">
                  $74.00 USD
                </span>
              </div>
              <div className="text-center md:text-right" data-id="element-423">
                <span className="block text-teal font-bold uppercase tracking-wider text-sm mb-1 flex items-center justify-center md:justify-end gap-1" data-id="element-424">
                  <CheckCircle2 size={16} data-id="element-425" /> Tu inversión hoy
                </span>
                <span className="text-5xl font-bold text-amber-dark" data-id="element-426">
                  $7.39 USD
                </span>
              </div>
            </div>
          </div>

          <div className="text-center max-w-2xl mx-auto" data-id="element-427">
            <p className="text-xl text-navy/80 leading-relaxed mb-4" data-id="element-428">
              Setenta y cuatro dólares en recursos. Lo que gastás en una cena
              familiar.
            </p>
            <p className="text-xl text-navy/80 leading-relaxed" data-id="element-429">
              Pero hoy, en esta página, el paquete completo sale{' '}
              <strong data-id="element-430">$7.39</strong>. No porque valga menos. Sino porque cada
              día que pasa sin un plan es otro día que tu hijo entra a la
              escuela sin escudo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}